<template>
  <div :class="{'absolute top-2 right-2': fixed}">
    <a
      href="javascript:void(0);"
      @click="favorite"
    >
      <i
        class="fa fa-heart text-lg"
        :class="{'text-red-500': favorited, 'text-gray-500': !favorited}"
      />
    </a>
  </div>
</template>

<script>
export default {

  props: {
    favorited: {
      type: Boolean,
      required: true,
    },

    fixed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  emits: ['favorite'],

  methods: {
    favorite() {
      this.$emit('favorite');
    },
  },
};
</script>
